import { Box, Collapse, Paper, Switch, Typography } from "@mui/material";
import { ReactNode, useState } from "react";
import { TurningChevron } from "../general/TurningChevron";
import { useCase } from "../../context/CaseContext";
import { useTheme } from "../../context/ThemeContext";

interface AgreementRowProps {
  label: string;
  expand?: boolean;
  active: boolean;
  onActiveChange: (active: boolean) => void;
  children: ReactNode;
}

export const AgreementRow = ({
  label,
  expand = false,
  active,
  onActiveChange,
  children,
}: AgreementRowProps) => {
  const { theme } = useTheme();
  const { readOnly } = useCase();
  const [expanded, setExpanded] = useState(expand);

  return (
    <Paper elevation={3} sx={{ p: theme.spacing(1) }}>
      <Box
        sx={{
          alignItems: "start",
          userSelect: "none",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <TurningChevron
            turn={expanded}
            onClick={() => setExpanded(!expanded)}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              userSelect: "none",
              cursor: "pointer",
            }}
          >
            {typeof label === "string" ? (
              <Typography onClick={() => setExpanded(!expanded)}>
                {label}
              </Typography>
            ) : (
              label
            )}
            <Switch
              checked={active}
              disabled={readOnly}
              onChange={(e) => onActiveChange(e.target.checked)}
              color="success"
            />
          </Box>
        </Box>

        <Collapse in={expanded}>
          <Box
            sx={{
              pl: theme.spacing(5),
              py: theme.spacing(2),
              pr: theme.spacing(2),
              pointerEvents: active ? "auto" : "none",
              opacity: active ? 1 : 0.6,
            }}
          >
            {children}
          </Box>
        </Collapse>
      </Box>
    </Paper>
  );
};
